/* import __COLOCATED_TEMPLATE__ from './question-bulk-select-actions.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

interface QuestionBulkSelectActionsSignature {
  Args: {
    isPlaygroundActive: boolean;
    areQuestionsBulkSelected: boolean;
    countOfFilteredQuestions: number;
    countOfBulkSelectedQuestions: number;
    areAnyFiltersApplied: boolean;
    updateShowConfirmTestRunModal: (showConfirmTestRunModal: boolean) => void;
    updateShowConfirmDeleteQuestionsModal: (showConfirmDeleteQuestionsModal: boolean) => void;
    openNewGroupModal: (place: string) => void;
  };
}

export default class QuestionBulkSelectActions extends Component<QuestionBulkSelectActionsSignature> {
  @service declare intercomEventService: $TSFixMe;
  @service declare appService: AppService;

  @action instrumentButtonClick(buttonType: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: buttonType,
      context: 'playground',
      question_count: this.args.countOfBulkSelectedQuestions,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::QuestionBulkSelectActions': typeof QuestionBulkSelectActions;
  }
}
